.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem;
}

.proof {
  width: 100%;
  border: 1px solid #758691;
  padding: 2rem;
  max-width: calc(41rem + 2px);
  margin: 0 auto;
  background-color: #f5f5f5;
  margin-bottom: 1rem;
  position: relative;
}

.proof::before {
  content: '';
  display: block;
  padding-top: 100%;
}

.proof > div {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  font-size: 1.25rem;
  text-align: center;
}

.imageWrap {
  position: relative;
  width: 75%;
  height: 75%;
  overflow: hidden;
}

/* Heavily blur a covered image (scaled up so the blur doesn't reveal soft edges). */
.blurred {
  filter: blur(40px) brightness(0.9);
  transform: scale(1.3);
}

.image {
  width: 100%;
  height: 100%;
  display: block;
  text-decoration: none;
  border-bottom: none;
  background-color: #ccc;
  image-rendering: pixelated;
  image-rendering: -moz-crisp-edges;
  image-rendering: crisp-edges;
}

/* The "pillowcase" — covers an image reported inappropriate until clicked. */
.pillowcase {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem;
  border: none;
  cursor: pointer;
  text-align: center;
  color: #fff;
  background-color: rgba(20, 24, 28, 0.55);
}

.pillowTitle {
  font-size: 1.7rem;
  font-weight: bold;
  line-height: 1.1;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.6);
}

.pillowSub {
  font-size: 0.85rem;
  max-width: 22rem;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.6);
}

.proof h3 {
  margin-bottom: 1rem;
  margin-top: 0;
  font-weight: normal;
}

.report {
  margin-top: 1rem;
  font-size: 0.75rem;
  cursor: pointer;
}
